import { Resolutions } from '../common/const';

/**
 * @tabs
 */
export const initTabs = () => {
    // Изменить класс
    function changeClass(target) {
        let tabBlocks = document.querySelectorAll(`[data-tab-block]`);

        tabBlocks.forEach((block) => {
            if (block.getAttribute(`data-tab-block`) === target.getAttribute(`data-tab`)) {
                block.classList.add(`active`);
                target.classList.add(`active`);
                $(target).siblings(`[data-tab]`).removeClass(`active`);
                $(block).siblings(`[data-tab-block]`).removeClass(`active`);

                if (target.getAttribute(`data-tab`).indexOf(`services-map`) !== -1) {
                    $(`[data-tab-block="services-list"]`).removeClass(`active`);
                }
            } else if (block.getAttribute(`data-tab-block`) === target.getAttribute(`data-tab-close`)) {
                block.classList.remove(`active`);
                document.querySelector(`[data-tab=${target.getAttribute(`data-tab-close`)}]`).classList.remove(`active`);
            }
        });
    }

    // По клику
    function onClick(e) {
        let target = e.target;

        if (target === target.closest(`[data-tab]`)) {
            const cond = target.getAttribute(`data-tab`).indexOf(`compare`) !== -1 && Resolutions.IS_TAB();
            if (!cond) {
                changeClass(target);
            }
        } else if (target === target.closest(`[data-tab-close]`)) {
            changeClass(target);
        }
    }

    // Изменение инпута
    function onChange(e) {
        let target = e.target;
        if ($(target).prop(`checked`)) changeClass(target);
    }

    function onHover(e) {
        const target = e.target;
        if (target === target.closest(`[data-tab]`) && target.hasAttribute(`data-tab-hover`) && Resolutions.IS_DP()) {
            changeClass(target);
        }
    }

    document.addEventListener(`click`, onClick);
    document.addEventListener(`mouseover`, onHover);
    $(`body`).on(`change`, `[data-tab]`, onChange);
};
